import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';

export interface IOrganisationExtraType extends IBaseEntity {
    id?: number;
    organisationId?: number;
    organisationName?: string;
    extraTypeId?: number;
    extraTypeDescription?: string;
    isActive?: boolean;
    enabledByDefault?: boolean;
    isDisplayedOnClientAddUpdateOrder?: boolean;
    forceManualRate?: boolean;
    fuelSurchargeApplies?: boolean;
    organisationDefaultFuelSurcharge?: number;
}

export class OrganisationExtraType extends BaseEntity implements IOrganisationExtraType {
    public id?: number;
    public organisationId?: number;
    public organisationName?: string;
    public extraTypeId?: number;
    public extraTypeDescription?: string;
    public isActive?: boolean;
    public enabledByDefault?: boolean;
    public isDisplayedOnClientAddUpdateOrder?: boolean;
    public forceManualRate?: boolean;
    public fuelSurchargeApplies?: boolean;
    public organisationDefaultFuelSurcharge?: number;

    constructor(organisationExtraType?: any) {
        super();
        if (organisationExtraType) {
            this.id = organisationExtraType.id;
            this.organisationId = organisationExtraType.organisationId;
            this.organisationName = organisationExtraType.organisationName;
            this.extraTypeId = organisationExtraType.extraTypeId;
            this.extraTypeDescription = organisationExtraType.extraTypeDescription;
            this.isActive = organisationExtraType.isEnabled;
            this.enabledByDefault = organisationExtraType.enabledByDefault;
            this.isDisplayedOnClientAddUpdateOrder = organisationExtraType.isDisplayedOnClientAddUpdateOrder;
            this.forceManualRate = organisationExtraType.forceManualRate;
            this.fuelSurchargeApplies = organisationExtraType.fuelSurchargeApplies;
            this.organisationDefaultFuelSurcharge = organisationExtraType.organisationDefaultFuelSurcharge;
        }
    }

    get discriminator(): any {
        return this.id;
    }

    clone(): OrganisationExtraType {
        return new OrganisationExtraType(this);
    }
}
